export default __webpack_public_path__ + "static/media/BlackCurtain4.5c2a6bf0.png";